import { render } from "./CommentInput.vue?vue&type=template&id=fc257f50&ts=true"
import script from "./CommentInput?vue&type=script&lang=ts&external"
export * from "./CommentInput?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__